{
  "add_metric": "Добавить ключевой показатель",
  "all_goals": "Все цели",
  "assignees": "Ответственные",
  "at_risk": "Под угрозой",
  "closed_goals": "Закрытые цели",
  "company_goal": "Стратегическая цель",
  "company_goal_caption": "Создайте стратегическую цель",
  "confidence": "Уверенность",
  "confidence_level": "Статус прогресса",
  "count_key_results_in_goal": "Количество ключевых результатов в цели",
  "create_goal": "Создать цель",
  "create_subgoal": "Создать подцель",
  "current_value": "Текущее значение",
  "deadline": "Срок выполнения",
  "delete_goal": "Удалить цель",
  "delete_goal_confirmation": "Вы уверены, что хотите удалить эту цель? Это действие нельзя отменить",
  "delete_goal_with_subgoals_question": "Эта цель содержит подцели. Что вы хотите сделать с ними?",
  "delete_metric_confirm": "Вы уверены, что хотите удалить данный ключевой показатель?",
  "delete_update": "Удалить обновление",
  "delete_update_confirm": "Вы уверены, что хотите удалить это обновление?",
  "department_goal": "Цель отдела",
  "department_goal_caption": "Владельцем цели будет руководитель отдела",
  "due_date_was": "Дата окончания была {date}",
  "edit_goal": "Редактировать цель",
  "edit_metric": "Редактировать ключевой показатель",
  "edit_metrics": "Редактировать ключевые показатели",
  "edit_update": "Редактировать обновление",
  "employee_goal": "Персональная цель",
  "employee_goal_caption": "Владельцем цели будет назначенный сотрудник",
  "expand_parent_chain": "Показать родительские цели",
  "explore": "Обзор",
  "end_date_from": "Дата окончания с",
  "end_date_to": "Дата окончания по",
  "goal": "Цель",
  "goal_not_found": "Не смогли найти цель",
  "goal_not_found_description": "Цель, которую вы ищете, не существует или была удалена",
  "goal_updated": "Цель обновлена",
  "goals": "Цели",
  "notification_settings_goals_caption": "Когда цели создаются, обновляются или завершаются",
  "notification_settings_key_results_title": "Ключевые показатели",
  "notification_settings_key_results_caption": "Когда ключевые показатели обновляются",
  "goals_empty_state_description": "Создайте первую цель, чтобы начать отслеживать прогресс",
  "goals_empty_state_title": "Целей пока нет",
  "initiatives_goals": "Инициативы",
  "last_update": "Обновлено",
  "last_updated": "Обновлено {time}",
  "metric_deleted": "Ключевой показатель удалён",
  "metric_type": "Тип ключевого показателя",
  "metric_type_boolean": "Да/Нет",
  "metric_type_currency": "Валюта",
  "metric_type_number": "Число",
  "metric_type_percentage": "Процент",
  "metrics": "Ключевые показатели",
  "my_goals": "Мои цели",
  "new_update": "Новое обновление",
  "no_goals": "Нет целей",
  "no_metrics": "Ключевых показателей пока нет",
  "no_metrics_description": "Добавьте ключевые показатели для отслеживания прогресса цели",
  "off_track": "Не по плану",
  "on_track": "По плану",
  "open_goals": "Открытые цели",
  "overdue": "Просрочено на {days}",
  "owner_type": "Тип владельца",
  "parent_goal": "Родительская цель",
  "percent_completed": "{percent} завершено",
  "permissions_company_description": "Создание, редактирование и удаление целей компании",
  "permissions_company_title": "Цели компании",
  "permissions_department_all_description": "Создание, редактирование и удаление целей всех отделов",
  "permissions_department_all_title": "Цели всех отделов",
  "permissions_department_own_description": "Создание, редактирование и удаление целей своего отдела",
  "permissions_department_own_title": "Цели ваших отделов",
  "permissions_module_description": "Доступ к модулю целей",
  "permissions_module_title": "Модуль целей",
  "permissions_team_all_description": "Создание, редактирование и удаление целей всех команд",
  "permissions_team_all_title": "Цели всех команд",
  "permissions_team_own_description": "Создание, редактирование и удаление целей своей команды",
  "permissions_team_own_title": "Цели ваших команд",
  "personal_goals": "Персональные цели",
  "privacy_private": "Приватная",
  "privacy_public": "Публичная",
  "quarter_format": "{quarter} кв. {year}",
  "recent_updates": "Последние обновления",
  "search_goals": "Все цели",
  "show_active_only": "Только активные",
  "show_all": "Показать все",
  "show_completed": "Показать завершённые",
  "specify_date": "Указать дату",
  "specify_date_description": "Дата может быть только сегодняшней или в прошлом",
  "start_date_from": "Дата начала с",
  "start_date_to": "Дата начала по",
  "start_value": "Начальное значение",
  "status_active": "Активная",
  "status_cancelled": "Отменена",
  "status_completed": "Завершена",
  "status_failed": "Не достигнута",
  "strategic_goals": "Стратегические",
  "sub_goals": "Подцели",
  "sub_goals_empty": "Подцелей пока не добавлено",
  "subgoals_delete_all": "Удалить все подцели",
  "subgoals_empty_add": "Добавить подцель",
  "subgoals_empty_description": "Добавьте подцели, чтобы разбить задачу на измеримые этапы",
  "subgoals_empty_title": "Нет подцелей",
  "subgoals_move_to_parent": "Переместить подцели на уровень выше",
  "target_value": "Целевое значение",
  "team_goal": "Цель команды",
  "team_goal_caption": "Владельцем цели будет руководитель команды",
  "timeline": "Хронология",
  "values": "Значения",
  "view_goal": "Открыть цель",
  "visible_to": "Видно для",
  "weight": "Вес"
}
